import { orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";

export type SearchOffersFormat = "all" | "vinyl" | "cd" | "cassette" | "video" | "other";
export type SearchOffersMovement = "up" | "down" | "flat" | "unknown";
export type SearchOffersSort = "best_price" | "price_drop" | "recent";

export interface SearchOffersQueryInput {
  includeMonitoredOfferCount?: boolean;
  condition?: "new" | "used";
  artistId?: string;
  artistIds?: string[];
  currency: string;
  cursor?: number;
  format: SearchOffersFormat;
  genre?: string[];
  limit: number;
  movement?: SearchOffersMovement;
  popularity?: number;
  priceMin?: number;
  priceMax?: number;
  sort: SearchOffersSort;
  style?: string[];
  yearFrom?: number;
  yearTo?: number;
}

export function getSearchOffersQueryOptions(input: SearchOffersQueryInput) {
  return orpc.deals.searchOffers.queryOptions({
    input,
    staleTime: QUERY_STALE_TIMES.dealOffers,
  });
}
